import * as TweenJS from "slotworks/utils/tween";
import Contract from "slotworks/utils/contract";
import Layers from "slotworks/graphics/layers/layers";
import { AbstractSceneTransition } from "slotworks/graphics/layers/scene-transitions/abstract-scene-transition";

export default class GlowOverTransitions extends AbstractSceneTransition {

    public in(): Contract<void> {        
        return new Contract(resolve => {
            const glitter = Layers.Custom.get("Glow").getParticle("glitter_explosion_fullscreen");
            const spine = Layers.Custom.get("Glow").getSpine("winmessages");
            spine.state.setAnimation(0, "glow_Stack_transition_full", false);
            spine.state.tracks[0].listener = {
                complete: () => setTimeout(resolve, 10)
            }            
            setTimeout(() => glitter.emit = false, 600);
        });
    }

    public out(): Contract<void> {
        return Contract.empty();
    }

}



// WEBPACK FOOTER //
// ./~/ifdef-loader/ifdef-loader.js??ref--0-1!./src/transitions/glow-over-transition.ts